import {
  useAcceptUserTermsMutation,
  UserAccountStatusDocument,
  UserAccountStatusQuery,
} from '../AccountVerification/operation.generated';

export default function useAcceptUserTerms(
  ...params: Parameters<typeof useAcceptUserTermsMutation>
) {
  const [options] = params;
  return useAcceptUserTermsMutation({
    update: (proxy, { data }) => {
      if (data?.acceptUserTerms.success) {
        const queryData = proxy.readQuery<UserAccountStatusQuery>({
          query: UserAccountStatusDocument,
        });
        if (queryData) {
          proxy.writeQuery<UserAccountStatusQuery>({
            query: UserAccountStatusDocument,
            data: {
              ...queryData,
              user: {
                ...queryData.user,
                hasAcceptedTerms: true,
              },
            },
          });
        }
      }
    },
    ...options,
  });
}
